export const NO_PUBLIC_DOCUMENTS_AVAILABLE = 'Note: No public documents available';
